import { useIsNative } from '~/context/common/DeviceContext';
import { useIsInExperiment } from '~/hooks/common';

export default function useIsInFavoritesAndSavedSearchExperiment() {
  const isNative = useIsNative();

  return (
    useIsInExperiment('merch-favorites-and-saved-searches', 'experiment') &&
    !isNative
  );
}
